import React from 'react';

const LanguageProvider = React.createContext<[string, any]>(['', {}]);

export default LanguageProvider;